import React from 'react';
import { useGlobalContext } from 'seagull';
import PaymentMethodLearnMoreModal from "./PaymentMethodLearnMoreModal";
export const usePaymentMethodLearnMoreModal = function usePaymentMethodLearnMoreModal() {
  let isDesktop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  const globalContext = useGlobalContext();
  return () => {
    globalContext.showModal({
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/React.createElement(PaymentMethodLearnMoreModal, {
          isDesktop: isDesktop,
          dismissModal: dismissModal
        });
      },
      closeOnClickOutside: true,
      closeOnEscapeKey: true
    });
  };
};